import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const NavbarContainer = styled(Box)`
  background-color: ${({ theme }) => theme.customColors.navbar};
  color: ${({ theme }) => theme.palette.text.primary};
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px 0 75px;
  position: fixed;
  width: 100%;
  z-index: 1;
  @media (max-width: 800px) {
    padding: 0;
  }
`;
const Menu = styled("span")`
  padding: 10px;
  font-size: 50px;
  font-weight: 700;
`;

export default function Navbar({ setShowSidebar }) {
  const [currentTime, setCurrentTime] = useState(dayjs());
  const navigate = useNavigate();
  const display = useSelector(state => state.auth.email);

  function getNameFromEmail(display) {
    if (!display) return "";
    return display.split("@")[0];
  }

  const handleLogoClick = (e) => {
    e.stopPropagation();
    navigate("/");   
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(dayjs());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    setShowSidebar((prev) => !prev);
  };
  const onCloseSideBar = () => {
    setShowSidebar(false);
  };

  return (
    <NavbarContainer onClick={onCloseSideBar}>
      {/* <Box className="is-mobile">
        <Menu onClick={handleClick}>{">"}</Menu>
      </Box> */}
      <Box onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/Logo_CPF.png`}
          width={50}
          alt="Logo_CPF"
          className="not-mobile"
        />
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/Logo_Engi.png`}
          width={80}
          alt="Logo_Engi"
          style={{ position: "relative", bottom: "4px" }}
        />
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/Logo_ImJAI.png`}
          width={120}
          alt="Logo_ImJAI"
          style={{ position: "relative", top: "14px" }}
        />
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Typography
          display={"flex"}
          alignItems={"center"}
          sx={{ fontSize: "20px" }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/Machine_User.png`}
            width={34}
            alt="user"
            className="img-user"
          />
          <span className="not-mobile">{getNameFromEmail(display)}</span>
        </Typography>
        <Typography
          className="gradient-text not-mobile"
          sx={{ fontSize: "25px", color: "#00C2A9", fontWeight: 800 }}
        >
          {currentTime.format("D MMM YYYY")}
        </Typography>
        <Typography
          className="gradient-text not-mobile"
          sx={{ fontSize: "30px", color: "#00C2A9", fontWeight: 800 }}
        >
          |
        </Typography>
        <Typography
          className="gradient-text not-mobile"
          sx={{ fontSize: "25px", color: "#00C2A9", fontWeight: 800 }}
        >
          {currentTime.format("HH:mm:ss")}
        </Typography>
      </Box>
    </NavbarContainer>
  );
}
